import { signInWithPopup, signOut, onAuthStateChanged } from "firebase/auth";
import { auth, googleProvider } from "../firebase";
import { trackEvent } from "../utils/helpers";

const ADMIN_EMAIL = "assubuildtech@gmail.com";

/**
 * Initiates Google Sign-In via popup
 */
export const signInWithGoogle = async () => {
  try {
    const result = await signInWithPopup(auth, googleProvider);
    trackEvent('admin_login_attempt', { email: result.user.email });
    
    // Check if the user is authorized immediately
    if (result.user.email !== ADMIN_EMAIL) {
      // Optional: Sign them out right away if they aren't authorized
      // await signOut(auth);
      throw new Error(`Access Denied. The account "${result.user.email}" is not authorized for Admin access.`);
    }

    trackEvent('admin_login_success', { email: result.user.email });
    return result.user;
  } catch (error) {
    console.error("Error during Google Sign In:", error);
    throw error;
  }
};

/**
 * Logs the current user out
 */
export const logout = async () => {
  try {
    await signOut(auth);
    trackEvent('admin_logout');
  } catch (error) {
    console.error("Error signing out:", error);
    throw error;
  }
};

/**
 * Subscribes to the authentication state stream.
 * Triggers callback whenever the user logs in or out.
 */
export const subscribeToAuthChanges = (callback) => {
  return onAuthStateChanged(auth, (user) => {
    callback(user);
  });
};
